import React from "react";

export default function Spinner({ label, className = "" }) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 py-16 ${className}`}
    >
      <span className="w-8 h-8 rounded-full border-[3px] border-gray-200 border-t-[#3969E7] animate-spin" />
      {label && <p className="text-sm otaLight">{label}</p>}
    </div>
  );
}
